"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
function MaybeLink(props) {
    if (props.to) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, Object.assign({}, props, { to: props.to }));
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
    }
}
exports.default = MaybeLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWF5YmVMaW5rLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL3dpZGdldHMvTWF5YmVMaW5rLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx1REFBbUQ7QUFNbkQsU0FBd0IsU0FBUyxDQUFDLEtBQXFCO0lBQ3JELElBQUksS0FBSyxDQUFDLEVBQUUsRUFBRTtRQUNaLE9BQU8sdUJBQUMsdUJBQUksb0JBQUssS0FBSyxJQUFFLEVBQUUsRUFBRSxLQUFLLENBQUMsRUFBRSxJQUFJLENBQUM7S0FDMUM7U0FBTTtRQUNMLE9BQU8sMkRBQUcsS0FBSyxDQUFDLFFBQVEsR0FBSSxDQUFDO0tBQzlCO0FBQ0gsQ0FBQztBQU5ELDRCQU1DIn0=